(() => {
  if (window.dtFestivalHeroCardLinksInitialized) return;
  window.dtFestivalHeroCardLinksInitialized = true;

  const panelSelector = '[data-dt-festival-panel-link]';
  const interactiveSelector =
    'a, button, input, select, textarea, summary, [role="button"], [role="link"], [contenteditable="true"]';

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      document.documentElement.classList.contains('shopify-design-mode')
    ) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) return;

    const panel = target.closest(panelSelector);
    if (!panel || target.closest(interactiveSelector)) return;

    const selection = window.getSelection?.();
    if (selection && !selection.isCollapsed) return;

    const href = panel.dataset.dtFestivalPanelLink?.trim();
    if (href) window.location.assign(href);
  });
})();
